export default __webpack_public_path__ + "static/media/similac600.5988e801.jpg";